import { createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7d199026")

_pushScopeId("data-v-7d199026")
const _hoisted_1 = { class: "bg-ff table-content" }
const _hoisted_2 = { class: "flex alignC top-button-group" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "c-60 mar-r-8 mar-l-16" }, "统计时间段", -1)
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"flex mar-t-16 mar-b-16\" style=\"gap:16px;flex-wrap:wrap;\" data-v-7d199026><div class=\"stat-card\" data-v-7d199026><div class=\"stat-card-title\" data-v-7d199026>录入到期总数</div><div class=\"stat-card-value c-red\" data-v-7d199026>120</div></div><div class=\"stat-card\" data-v-7d199026><div class=\"stat-card-title\" data-v-7d199026>跟进总数</div><div class=\"stat-card-value\" data-v-7d199026>66</div></div><div class=\"stat-card\" data-v-7d199026><div class=\"stat-card-title\" data-v-7d199026>成交总数</div><div class=\"stat-card-value c-green\" data-v-7d199026>66</div></div><div class=\"stat-card\" data-v-7d199026><div class=\"stat-card-title\" data-v-7d199026>整体成交率</div><div class=\"stat-card-value c-red\" data-v-7d199026>66.66%</div></div><div class=\"stat-card\" data-v-7d199026><div class=\"stat-card-title\" data-v-7d199026>商业险总金额</div><div class=\"stat-card-value\" data-v-7d199026>¥111,000</div></div><div class=\"stat-card\" data-v-7d199026><div class=\"stat-card-title\" data-v-7d199026>交强险总金额</div><div class=\"stat-card-value\" data-v-7d199026>¥111,000</div></div></div>", 1)
const _hoisted_5 = { class: "flex flexR mar-t-22" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_pagination = _resolveComponent("el-pagination")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_el_date_picker, {
        modelValue: _ctx.dateRange,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.dateRange = $event)),
        class: "mar-r-16",
        type: "daterange",
        align: "right",
        "unlink-panels": "",
        "range-separator": "-",
        "start-placeholder": "开始日期",
        "end-placeholder": "结束日期"
      }, null, 8, ["modelValue"])
    ]),
    _hoisted_4,
    _createVNode("div", null, [
      _createVNode(_component_el_table, {
        data: _ctx.pagedDetail,
        stripe: "",
        style: {"width":"100%"},
        class: "table",
        "header-cell-style": _ctx.headClass
      }, {
        default: _withId(() => [
          _createVNode(_component_el_table_column, {
            label: "日期",
            align: "center",
            "min-width": "100"
          }, {
            default: _withId((scope) => [
              _createTextVNode(_toDisplayString(scope.row.date), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "专员",
            align: "center",
            "min-width": "80"
          }, {
            default: _withId((scope) => [
              _createTextVNode(_toDisplayString(scope.row.name), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "录入到期数",
            align: "center",
            "min-width": "100"
          }, {
            default: _withId((scope) => [
              _createTextVNode(_toDisplayString(scope.row.expire_count), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "跟进数",
            align: "center",
            "min-width": "80"
          }, {
            default: _withId((scope) => [
              _createTextVNode(_toDisplayString(scope.row.follow_count), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "成交数",
            align: "center",
            "min-width": "80"
          }, {
            default: _withId((scope) => [
              _createTextVNode(_toDisplayString(scope.row.deal_count), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "成交率",
            align: "center",
            "min-width": "80"
          }, {
            default: _withId((scope) => [
              _createVNode("span", {
                class: scope.row.deal_rate >= 50 ? 'c-red' : ''
              }, _toDisplayString(scope.row.deal_rate) + "% ", 3)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "商业险金额",
            align: "center",
            "min-width": "110"
          }, {
            default: _withId((scope) => [
              _createTextVNode("¥" + _toDisplayString(scope.row.commercial_amount), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "交强险金额",
            align: "center",
            "min-width": "110"
          }, {
            default: _withId((scope) => [
              _createTextVNode("¥" + _toDisplayString(scope.row.ci_amount), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "总金额",
            align: "center",
            "min-width": "100"
          }, {
            default: _withId((scope) => [
              _createTextVNode("¥" + _toDisplayString(scope.row.total_amount), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data", "header-cell-style"])
    ]),
    _createVNode("div", _hoisted_5, [
      _createVNode(_component_el_pagination, {
        onSizeChange: _ctx.handleSizeChange,
        onCurrentChange: _ctx.handleCurrentChange,
        "current-page": _ctx.currentPage,
        "page-sizes": [10, 20, 50],
        "page-size": _ctx.pageSize,
        layout: "total, sizes, prev, pager, next, jumper",
        total: _ctx.mockData.length
      }, null, 8, ["onSizeChange", "onCurrentChange", "current-page", "page-size", "total"])
    ])
  ]))
})